<template>
  <div class="messUpload">
    <ul class="talTitle" :style="fileArr.length ? '' : 'visibility: hidden;'">
      <li>序号</li>
      <li>文档名称</li>
      <li>进度</li>
      <li></li>
      <li>源语言</li>
      <li>删除</li>
    </ul>
    <el-upload class="upload-demo" drag action :http-request="uploadSectionFile" multiple list-type="text"
      :show-file-list="false" :file-list="fileArr" :limit="uploadNumber" :on-exceed="handleExceed"
      :before-upload="beforeUploadFile" :on-progress="uploadFileProcess" :on-success="handleFileSuccess"
      :on-change="uploadChange" :accept="acceptStr">
      <div class="uploadBox" v-if="fileArr.length ? false : true">
        <i></i>
        <img src="../assets/imgs/project/normal_upload.png" alt />
        <div class="el-upload__text">
          支持 ({{formatArr}}) 拖拽或点击上传
          <em style="display:block">单个文件{{fileLimit}}M以下，本项目最多{{uploadNumber}}个文件</em>
        </div>
      </div>

      <template>
        <!-- <ul>
          <li v-for="(item,index) in fileArr" :key="index">
            <span>序号</span>
            <span>文档名称</span>
            <span>进度</span>
            <span>字数</span>
            <span>源语言</span>
            <span>删除</span>
          </li>
        </ul>-->
        <ul class="tab">
          <li v-for="(item,index) in fileArr" :key="index">
            <span class="serial">{{index+1}}</span>
            <span class="nam">
              <img :src="item.imgSrc" alt />
              {{item.name}}
            </span>
            <span class="progress">
              <!-- <template slot-scope="scope"> -->
              <el-progress :show-text="false" :stroke-width="8"
                :percentage="isNaN(item.percentage) ? 100 : item.percentage" class="progress">
              </el-progress>
              <p>{{item.percentage + (isNaN(item.percentage) ? "" : "%")}}</p>
              <!-- </template> -->
            </span>
            <span class="siz"></span>
            <span class="source1">{{item.source}}</span>
            <span class="del">
              <!-- <template slot-scope="scope"> -->
              <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                <i class="icon-delete" @click.stop="handleDelete(index)"></i>
              </el-tooltip>
              <!-- </template> -->
            </span>
          </li>
        </ul>
        <div class="bot_box" v-if="fileArr.length ? true : false">
          <span>*点击或拖拽上传</span>
        </div>
      </template>
    </el-upload>
    <div v-show="false">{{refresh}}</div>
  </div>
</template>

<script>

import axios from "axios";
// import { FilterFileCategory, LimitSize } from '../../public/extract'
export default {
  name: "messUpload",
  props: ["isCall"],
  data() {
    return {
      fileArr: [],
      data: [],
      obp: true,
      refresh: 0,
      formatArr: "",
      acceptStr: "",
      fileLimit: "",
      uploadNumber: parseInt(UPLOAD_NUMBER)
    };
  },
  components: {},
  watch: {
    isCall() {
      this.callFileArr();
    }
  },
  created() {
    this.formatArr = FilterFileCategory().formatArr.join("、")
    this.acceptStr = FilterFileCategory().acceptArr.join(",")
    this.fileLimit = LimitSize().limit
    // if (process.env.VUE_APP_NAME === "nation") {
    //   this.notGetLong = true;
    // }
  },
  methods: {
    // 获取语言
    getLong(path, param) {
      var that = this;
      this.catReq1Service(`/api/v1/file/language`, {
        path
      }, "post", 2)
        .then(function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;
          if (data == null) {
            that.refresh++;
            return;
          }
          that.fileArr.forEach(item => {
            if (item.uid === param.file.uid) {
              // vm.$set(vm.item, 'source', response.data.result.dataValue)
              item.source = data.sourceLangName || "";
              // item.wordNumber = data.remark || "";
              item.sourceLang = data.sourceLang || "";
              // that.fileArr.item = Object.assign({}, that.fileArr.item, { source: data})
            }
          });
          that.refresh++;
          that.$store.commit("setFileList", that.fileArr);
          // that.fileArr = ary;
          // // console.log(that.fileArr);
        });
    },
    // 清空
    callFileArr() {
      this.fileArr = [];
    },
    // 进度条参数
    percentageFn(index, row) {
      // console.log(row);
      return row.progressPercent;
    },
    // 删除文件
    handleDelete(index) {
      var that = this;
      this.fileArr.splice(index, 1);
      this.data.splice(index, 1);
    },
    // 上传的第二个函数
    getFileHost(param) {
      var that = this;
      // alert(that.host)
      var FileController = that.host;
      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios.post(FileController, that.formData, config)

        .then(function (response) {
          if (!response) {
            return;
          }
          // console.log(response.data.result);
          if (!that.notGetLong) {
            that.getLong(response.data.result.fileName, param);
          }

          that.fileArr.forEach(item => {
            if (item.uid === param.file.uid) {
              item.path = response.data.result.fileName;
            }
          });
          let ary = [];
          let re = /([^\.\/\\]+)\.([a-z]+)$/i; // 匹配拿到后缀
          that.fileArr.forEach(item => {
            let resultArr = re.exec(item.name);
            let type = resultArr[2];
            ary.push({
              name: item.name,
              filePath: item.path,
              fileSuffix: type
            });
          });
          // that.$store.commit("setFileList", ary);
          that.data = ary;
          that.$emit("getMessForm", that.data);
        })
        .catch(function (error) {
          //  that.fileArr.forEach(item => {
          //   if (item.name == param.file.name) {
          //     item.exception = "exception";
          //     item.percentage = "上传失败";
          //   }
          // });
        });
    },
    // 上传函数——获取签名
    uploadSectionFile(param) {
      if (param.file.obp) {
        return;
      }
      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      var code = localStorage.getItem("myCompanyCode");
      //自定义文件上传
      // // console.log(param);
      var url = "/api/v1/file/getUploadSign";
      var params = { companyCode: code, fileType: "project" };
      this.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          // console.log(key, data[key]);
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost(param);
      });
    },
    handleExceed() {
      this.$message({
        message: `最多${this.uploadNumber}个文件`,
        type: "warning"
      });
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile(file) {
      var that = this;
      let type = this.typeReg(file.name) // 拿到文件后缀
      const isDOCX = type === "docx";
      const isDOC = type === "doc";
      const isTXT = type === "txt";
      const isXLS = type === "xls";
      const isXLSX = type === "xlsx";
      const isPDF = type === "pdf";
      const isPPT = type === "ppt";
      const isPPTX = type === "pptx"
      const isHTML = type === "html"

      const isLt20M = file.size / 1024 / 1024 < 20;
      if (FilterFileCategory(type).isFormat) {
        this.$message.closeAll();
        this.$message({
          message: `只支持 ${FilterFileCategory(type).formatArr.join("、")}格式!`,
          type: "warning"
        });
        file.obp = true;
        return false;
      }

      if (!LimitSize(file.size).size) {
        this.$message.closeAll();
        this.$message({
          message: `上传文件大小不能超过 ${LimitSize(file.size).limit}MB!`,
          type: "warning"
        });
        file.obp = true;
        return false;
      }
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      // let type = true;
      // this.$store.state.myRow.forEach(i => {
      //   this.fileArr.slice(0, -1).forEach(item => {
      //     if (i.name === item.name) {
      //       this.fileArr.pop();
      //       type = false;
      //     }
      //   });
      // });
      // if (!type) {
      //   this.$message({
      //     message: "上传文件与原文件名称重复!",
      //     type: "warning"
      //   });
      // }
      this.fileArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.fileArr.pop();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = true;
          return false;
        }
      });
      return (!FilterFileCategory(type).isFormat) && isLt20M;
    },
    // 文件图标
    uploadChange(event, file, fileList) {
      this.fileArr = file;
      this.fileArr.forEach(item => {
        // console.log(item, "sssssssssssssss");
        if (item.raw) {
          switch (this.typeReg(item.name)) {
            case "pdf":
              item.imgSrc = require("../assets/imgs/project/press_pdf.icon.png");
              this.qwer = "pdf";
              break;
            case "doc":
              item.imgSrc = require("../assets/imgs/project/press_word.icon.png");
              this.qwer = "doc";
              break;
            case "docx":
              item.imgSrc = require("../assets/imgs/project/press_word.icon.png");
              break;
            case "ppt":
              item.imgSrc = require("../assets/imgs/project/press_ppt.icon.png");
              break;
            case "pptx":
              item.imgSrc = require("../assets/imgs/project/press_ppt.icon.png");
              break;
            case "xls":
              item.imgSrc = require("../assets/imgs/project/press_xlsx.icon.png");
              break;
            case "xlsx":
              item.imgSrc = require("../assets/imgs/project/press_xlsx.icon.png");
              break;
            case "txt":
              item.imgSrc = require("../assets/imgs/project/txt.png");
              break;
            case "html":
              item.imgSrc = require("../assets/imgs/project/html.png");
              break;
            case "htm":
              item.imgSrc = require("../assets/imgs/project/html.png");
              break;
            case "xlf":
              item.imgSrc = require("../assets/imgs/project/xlf.png");
              break;
            case "eml":
              item.imgSrc = require("../assets/imgs/project/eml.png");
              break;
            default:
              break;
          }
        }
      });
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file, fileList) {
      // // console.log(fileList, "???????");
      // // console.log(file);
      // // console.log(event);
      // // this.fileArr = fileList;
      // if (event.percent==100) {
      //   this.fileArr.push(file)
      // }
      // this.fileArr.forEach(item => {
      //   if (item.percentage == 100) {
      //   } else {
      //     // item.progressFlag = true;
      //     // console.log(item.percentage);
      //     item.progressPercent = Math.abs(item.percentage.toFixed(0));
      //     // console.log(item.progressPercent);
      //   }
      // });
    },

    //文件上传成功的函数(用于文件上传成功之后的逻辑)
    handleFileSuccess(res, file, fileList) {
      var that = this;
      // console.log(fileList, "333333");
      // console.log(file);
      // console.log(res);
      this.fileArr = fileList;
      that.$emit("getMessForm", that.fileArr);
      this.fileArr.forEach((item, index) => {
        // item.progressFlag = false;
        // if (item.status == "success") {
        //   item.successFlag = true;
        // } else {
        //   item.successFlag = false;
        // }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.messUpload {
  .talTitle {
    width: 712px;
    margin: 0 auto;
    height: 46px;
    li {
      float: left;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
    }
    li:nth-child(1) {
      width: 70px;
    }
    li:nth-child(2) {
      width: 300px;
      text-align: left;
    }
    li:nth-child(3) {
      width: 70px;
    }
    li:nth-child(4) {
      width: 100px;
    }
    li:nth-child(5) {
      width: 100px;
    }
    li:nth-child(6) {
      width: 50px;
    }
  }
  .bot_box {
    position: absolute;
    bottom: 5px;
    height: 15px;
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
    .el-upload__text{
      line-height: 24px;
    }
    span {
      float: left;
      margin-left: 20px;
    }
    button {
      float: right;
      width: 70px;
      height: 28px;
      margin-top: 0px;
      margin-right: 68px;
      font-size: 12px;
      line-height: 28px;
    }
  }
  .tab {
    height: 285px;
    overflow: auto;
    padding: 10px;
    li {
      height: 46px;
      width: 670px;
      color: rgba(102, 102, 102, 1);
      font-size: 12px;
      margin: 0 auto;
      .del {
        .icon-delete {
          display: inline-block;
          width: 20px;
          height: 18px;
          background: url("../assets/imgs/memory/delete_normal.png") no-repeat;
          vertical-align: middle;
        }
        // .icon-delete:hover {
        //   background: url("../assets/imgs/memory/delete_hover.png") no-repeat;
        // }
        .icon-delete:active {
          background: url("../assets/imgs/memory/delete_press.png") no-repeat;
        }
      }
      span {
        // color: aqua;
        float: left;
        height: 46px;
        line-height: 46px;
        p {
          height: 18px;
          line-height: 18px;
        }
        /deep/ .el-progress-bar__outer {
          margin: 7px 0 5px 0;
          background-color: #b1b1b1;
        }
        /deep/.el-progress-bar__inner {
          background: rgba(102, 102, 102, 1) !important;
        }
      }
      span:nth-child(1) {
        width: 40px;
      }
      span:nth-child(2) {
        width: 310px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        img {
          margin-bottom: -2px;
          margin-right: 5px;
        }
      }
      span:nth-child(3) {
        width: 70px;
      }
      span:nth-child(4) {
        width: 100px;
      }
      span:nth-child(5) {
        width: 100px;
      }
      span:nth-child(6) {
        width: 50px;
      }
    }
    li:hover {
      background: rgba(210, 210, 210, 1);
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.35);
      border-radius: 1px;
    }
  }
  .uploadBox {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .el-upload__text{
      line-height: 24px;
    }
    img {
      margin-bottom: 30px;
    }
  }
  /deep/.upload-demo {
    width: 712px;
    height: 310px;
    margin: 0 auto;
    background: rgba(241, 241, 241, 1);
    // border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 2px;
    .el-table th,
    .el-table tr {
      background: rgba(241, 241, 241, 1);
    }
  }
  /deep/.el-upload-dragger {
    position: relative;
    width: 712px;
    height: 310px;
    background: rgba(241, 241, 241, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 2px;
  }
  /deep/.el-progress-bar__innerText {
    line-height: 15px;
  }
}
</style>